import React from 'react'

const FormDescription = ({ htmlContent }) => (
  <div
    className="mb-12 u-p copy link-wrapper"
    dangerouslySetInnerHTML={{ __html: htmlContent }}
  />
)

export default FormDescription
